import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';

const metrics = [
    {
        name: 'Wydajność',
        definition: 'Liczba mandatów za parkowanie wystawiona przez jednego strażnika w ciągu miesiąca',
        normalization: '↑ min-max obserwowany (0–14,3 mandatów/strażnik/miesiąc)',
        max: 200,
    },
    {
        name: 'Pobłażliwość',
        definition: 'Udział pouczeń w łącznej liczbie interwencji parkingowych (mandaty + pouczenia)',
        normalization: '↓ progi: ≤10% = maks., ≥50% = 0 pkt – straże wystawiające mandaty w mniej niż połowie interwencji są oceniane niżej',
        max: 100,
    },
    {
        name: 'Blokady',
        definition: 'Liczba założonych blokad kół na jednego strażnika w ciągu miesiąca',
        normalization: '↑ min-max obserwowany (0–6,8 blokad/strażnik/miesiąc)',
        max: 100,
    },
    {
        name: 'Holowania',
        definition: 'Liczba holowań pojazdów innych niż wraki na 100 tys. mieszkańców rocznie',
        normalization: '↑ min-max obserwowany (0–798 holowań/100k)',
        max: 100,
    },
    {
        name: 'Holowanie z przejść',
        definition: 'Liczba holowań za stwarzanie zagrożenia (m.in. blokowanie przejść dla pieszych) na 100 tys. mieszkańców rocznie',
        normalization: '↑ min-max obserwowany (0–18,1 holowań/100k)',
        max: 100,
    },
    {
        name: 'Holowanie wraków',
        definition: 'Liczba holowań pojazdów uznanych za wraki na 100 tys. mieszkańców rocznie',
        normalization: '↑ min-max obserwowany (0–88 wraków/100k)',
        max: 100,
    },
    {
        name: 'Współpraca',
        definition: 'Odsetek zgłoszeń z systemu czas-reakcji (urząd dzielnicy / miasta) zamkniętych przez straż',
        normalization: '↑ progi: 0% = 0 pkt, 100% = maks. (naturalna granica)',
        max: 100,
    },
    {
        name: 'Niesprawiedliwość',
        definition: 'Stosunek łącznej kwoty opłat dodatkowych nałożonych przez operatora SPP do wartości mandatów za nieprawidłowe parkowanie wystawionych przez straż miejską',
        normalization: '↓ progi: ≤0,3 × = maks., ≥3 × = 0 pkt; miasta bez danych SPP otrzymują 0 pkt',
        max: 100,
    },
    {
        name: 'Strażnicy',
        definition: 'Liczba etatów strażników na 100 tys. mieszkańców',
        normalization: '↑ min-max obserwowany (10–68 strażników/100k)',
        max: 100,
    },
    {
        name: 'Budżet',
        definition: 'Roczny budżet straży podzielony przez liczbę mieszkańców',
        normalization: '↑ progi: ≤10 zł/mieszkańca = 0 pkt, ≥140 zł/mieszkańca = maks.',
        max: 50,
    },
    {
        name: 'Mandaty PRD',
        definition: 'Udział mandatów za nieprawidłowe parkowanie w ogólnej liczbie wystawionych mandatów',
        normalization: '↓ progi: ≤50% = maks., ≥80% = 0 pkt – straże skupione niemal wyłącznie na parkowaniu są oceniane niżej',
        max: 50,
    },
    {
        name: 'Koszt mandatu',
        definition: 'Roczny budżet straży podzielony przez łączną liczbę wystawionych mandatów',
        normalization: '↓ progi: ≤794 zł/mandat = maks., ≥3\u00a0000 zł/mandat = 0 pkt',
        max: 50,
    },
    {
        name: 'Wynagrodzenie',
        definition: 'Mediana wynagrodzeń brutto strażników; jednostki bez danych otrzymują minimalną wartość obserwowaną w zbiorze',
        normalization: '↑ min-max obserwowany (4\u00a0900–9\u00a0792 zł brutto)',
        max: 50,
    },
];

export default function gridMetodologia(id) {
    if (!document.getElementById(id)) return;

    Grid.grid(id, {
        dataTable: {
            columns: {
                'Metryka': metrics.map(m => m.name),
                'Definicja': metrics.map(m => m.definition),
                'Normalizacja': metrics.map(m => m.normalization),
                'Maks.\u00a0pkt': metrics.map(m => m.max),
            }
        },
        rendering: {
            rows: {
                strictHeights: false
            },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [
            {
                id: 'Metryka',
                cells: { className: 'bold' },
                width: 140,
            },
            {
                id: 'Definicja',
            },
            {
                id: 'Normalizacja',
            },
            {
                id: 'Maks. pkt',
                cells: { className: 'cell-right' },
                width: 70,
            },
        ]
    });
}
